export default "__VITE_ASSET__CiUWcd8v__"